import { useDroppable } from '@dnd-kit/core';
import { Space, Typography } from 'antd';
import React from 'react';

import DraggableVehicleChip from './DraggableVehicleChip';

const DroppableRateClass = ({ assignedVehicles, classification, isEditing, onRemoveVehicle, vehicles }) => {
  const { isOver, setNodeRef } = useDroppable({
    data: {
      classId: classification.id,
      type: 'rate-class',
    },
    id: `class-${classification.id}`,
  });

  return (
    <div
      ref={setNodeRef}
      className={`class-list__rate-class-drop-zone ${isOver ? 'dragging-over' : ''} ${isEditing ? 'editing' : ''}`}
    >
      {assignedVehicles.length > 0 ? (
        <Space wrap size={[8, 8]}>
          {assignedVehicles.map((vehicle) => (
            <DraggableVehicleChip
              key={vehicle.id}
              isEditing={isEditing}
              showRemove={true}
              vehicle={vehicle}
              onRemove={() => onRemoveVehicle(classification.id, vehicle.id)}
            />
          ))}
        </Space>
      ) : (
        <Typography.Text style={{ display: 'block', padding: '20px', textAlign: 'center' }} type="secondary">
          Drop vehicle types here
        </Typography.Text>
      )}
    </div>
  );
};

export default DroppableRateClass;

